import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// 生成订单编号
export function generateOrderNo(): string {
  const now = new Date()
  const dateStr = now.getFullYear().toString() +
    String(now.getMonth() + 1).padStart(2, '0') +
    String(now.getDate()).padStart(2, '0')
  const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0')
  return `CK${dateStr}${random}`
}

// 计算配送费
export function calculateFreight(distance: number): number {
  if (distance <= 3) return 8
  if (distance <= 5) return 12
  if (distance <= 10) return 18
  return -1 // 超出配送范围
}

// 格式化价格
export function formatPrice(price: number): string {
  return `¥${price.toFixed(2)}`
}

// 模拟配送距离（湘潭本地）
export function getDistance(address: string): number {
  // 根据地址关键词返回模拟距离（公里）
  const coreAreas = ['建设路口', '岳塘区政府', '基建营', '步步高', '东方红广场', '芙蓉路', '双拥路']
  const midAreas = ['板塘铺', '河东大道', '福星路', '湘潭大学', '湖南科大']
  
  if (coreAreas.some(area => address.includes(area))) return 1.5 + Math.random() * 1.5
  if (midAreas.some(area => address.includes(area))) return 3 + Math.random() * 2
  return 5 + Math.random() * 3
}

// 时间格式化
export function formatDateTime(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth()+1).padStart(2,'0')}-${String(date.getDate()).padStart(2,'0')} ${String(date.getHours()).padStart(2,'0')}:${String(date.getMinutes()).padStart(2,'0')}`
}
